/**
 * t1-noHot 落地页 — 移动端补充脚本
 * 轮播初始化统一由 t1-noHot_pc.js 的 t1NoHotPageInit 处理（按容器 scoped，避免重复 class 冲突）
 * 本文件仅保留移动端特有逻辑
 */
(function () {
  if (window.innerWidth >= window.T1_NOHOT_BP_PC) {
    return;
  }

  var orientationRefreshTimer = null;

  /** 横竖屏切换后刷新 ScrollTrigger（若主题已加载 GSAP） */
  function bindOrientationRefresh() {
    window.addEventListener('orientationchange', function () {
      if (orientationRefreshTimer) {
        clearTimeout(orientationRefreshTimer);
      }
      if (typeof ScrollTrigger === 'undefined') {
        return;
      }
      orientationRefreshTimer = setTimeout(function () {
        ScrollTrigger.refresh();
      }, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindOrientationRefresh);
  } else {
    bindOrientationRefresh();
  }
})();
